<template>
  <div class="alert" data-animation="fadeInTop">
    <BaseIcon
      v-if="icon"
      v-bind="icon"
      class="alert__icon"
    />
    <BaseTitle
      v-if="title"
      v-bind="title"
      class="alert__title"
    />
    <BaseText
      v-if="description"
      v-bind="description"
      class="alert__description"
    />
    <div v-if="actions.length" class="alert__actions">
      <BaseButton
        v-for="(item, i) in actions"
        :key="`alert_action_${i}`"
        v-bind="item"
        class="alert__action"
        @click="item.action ? item.action() : null"
      />
    </div>
    <slot />
  </div>
</template>

<script>
import BaseIcon from '@/components/BaseIcon.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'BaseAlert',
  components: {
    BaseIcon,
    BaseTitle,
    BaseText,
    BaseButton,
  },
  props: {
    icon: {
      type: Object,
      default: null,
    },
    title: {
      type: Object,
      default: null,
    },
    description: {
      type: Object,
      default: null,
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="stylus">
.alert
  display block
  text-align center

  &__icon
    margin 0 auto 1.25em auto

  &__description
    max-width 40em
    margin 0.4em auto 0 auto

  &__actions
    margin-top 2em

  &__action
    margin-left 0.4em
    margin-right @margin-left
</style>
